<template>
  <UikitDialog
    :model-value="modelValue"
    full-height
    full-width
    content-class="osk-product-gallery-dialog"
    @update:model-value="emits('update:modelValue', $event)"
  >
    <div class="osk-product-gallery-dialog__content">
      <ProductGallery
        class="osk-product-gallery-dialog__gallery"
        :product="product"
        :current-image="currentImage"
        :images="images"
        zoom
      />

      <GalleryZoom />
    </div>
  </UikitDialog>
</template>

<script setup lang="ts">
import { ProductImageDTO, ProductDTORes } from '~/restAPI/data-contracts';

const props = defineProps<{
  modelValue: boolean
  product?: ProductDTORes
  currentImage?: ProductImageDTO
  images?: ProductImageDTO[],
}>();

const emits = defineEmits<{
  (e: 'update:modelValue', value: boolean): void,
}>();
</script>

<style lang="scss">
@import "~/assets/scss/settings/index";

.osk-product-gallery-dialog {
  padding: 48px 0 0 !important;

  @include media-query(md-and-up) {
    padding: 24px !important;
  }

  .osk-dialog__close {
    top: 16px;
    right: 16px;
  }

  &__content {
    height: 100%;
  }

  @include media-query(lg-and-up) {
    overflow-y: auto;
    height: 100vh;
    width: calc(100vw - 32px);
  }

  .swiper-pagination {
    left: 0 !important;
  }

  &__gallery {
    @include media-query(lg-and-up) {
      width: 745px !important;
      margin: 0 auto;
    }
  }
}
</style>
